import React, { ReactNode } from 'react'
import { ContentSmall } from '../../design-system'
import { Panel } from '../../design-system'
import { ContentAccordion } from '../molecules'

interface FAQQuestionProps {
  q?: string
  analyticsEvent?: string
  children: ReactNode
}

export const FAQQuestion = ({
  q,
  children,
  analyticsEvent,
}: FAQQuestionProps) => (
  <ContentAccordion label={q} analyticsEvent={analyticsEvent}>
    <Panel>
      <ContentSmall>{children}</ContentSmall>
    </Panel>
  </ContentAccordion>
)
